export const ABANDON_ADD_ANOTHER_DEVICE = 'ABANDON_ADD_ANOTHER_DEVICE';
export const ACCEPT_OEM_DISCLAIMER = 'ACCEPT_OEM_DISCLAIMER';
export const ADD_ANOTHER_DEVICE = 'ADD_ANOTHER_DEVICE';
export const BATCH_FETCHED = 'BATCH_FETCHED';
export const BATCH_FETCHED_ERROR = 'BATCH_FETCHED_ERROR';
export const BATCH_FETCHING = 'BATCH_FETCHING';
export const BILLING_CITY_CHANGED = 'BILLING_CITY_CHANGED';
export const BILLING_STATE_CHANGED = 'BILLING_STATE_CHANGED';
export const BILLING_STREET_CHANGED = 'BILLING_STREET_CHANGED';
export const BILLING_ZIP_CHANGED = 'BILLING_ZIP_CHANGED';
export const CANCEL_COMMENT_CHANGED = 'CANCEL_COMMENT_CHANGED';
export const CANCEL_REPAIR_FAILURE = 'CANCEL_REPAIR_FAILURE';
export const CANCEL_REPAIR_SUCCESS = 'CANCEL_REPAIR_SUCCESS';
export const CANCELING_REPAIR = 'CANCELING_REPAIR';
export const CERTIFICATION_OPTION_TOGGLED = 'CERTIFICATION_OPTION_TOGGLED';
export const CHANGE_SELECTED_DAY = 'CHANGE_SELECTED_DAY';
export const CHANGE_TO_NEXT_STEP_FOR_PRELOADED_CUSTOMER =
  'CHANGE_TO_NEXT_STEP_FOR_PRELOADED_CUSTOMER';
export const CHANGE_TO_CONTACT = 'CHANGE_TO_CONTACT';
export const CHANGE_TO_DEVICE = 'CHANGE_TO_DEVICE';
export const CHANGE_TO_SERVICE_OPTION = 'CHANGE_TO_SERVICE_OPTION';
export const CHANGE_TO_TIME = 'CHANGE_TO_TIME';
export const CHANGE_TO_TRACKING = 'CHANGE_TO_TRACKING';
export const CHANGED_TO_LOCATION = 'CHANGED_TO_LOCATION';
export const CHANGE_TO_ON_SITE_LOCATION = 'CHANGE_TO_ON_SITE_LOCATION';
export const CHANGE_TO_IN_STORE_LOCATION = 'CHANGE_TO_IN_STORE_LOCATION';
export const CHANGED_TO_PAYMENT = 'CHANGED_TO_PAYMENT';
export const CHANGED_TO_SUBMIT = 'CHANGED_TO_SUBMIT';
export const CHANGED_UNIT_NUMBER = 'CHANGED_UNIT_NUMBER';
export const CHECK_ROUTE_ON_LOAD = 'CHECK_ROUTE_ON_LOAD';
export const CREATE_REVIEW_SUCCESS = 'CREATE_REVIEW_SUCCESS';
export const CREATE_REVIEW_FAILURE = 'CREATE_REVIEW_FAILURE';
export const CREATING_REVIEW = 'CREATING_REVIEW';
export const CREATING_STRIPE_CUSTOMER = 'CREATING_STRIPE_CUSTOMER';
export const CREATING_REPAIR = 'CREATING_REPAIR';
export const CREATE_REPAIR_SUCCESS = 'CREATE_REPAIR_SUCCESS';
export const CREATE_REPAIR_FAILURE = 'CREATE_REPAIR_FAILURE';
export const CREDIT_CARD_CVC_CHANGED = 'CREDIT_CARD_CVC_CHANGED';
export const CREDIT_CARD_EXP_CHANGED = 'CREDIT_CARD_EXP_CHANGED';
export const CREDIT_CARD_NUMBER_CHANGED = 'CREDIT_CARD_NUMBER_CHANGED';
export const CUSTOMER_DETAILS_FETCHING = 'CUSTOMER_DETAILS_FETCHING';
export const CUSTOMER_DETAILS_FETCHED_ERROR = 'CUSTOMER_DETAILS_FETCHED_ERROR';
export const CUSTOMER_DETAILS_FETCHED = 'CUSTOMER_DETAILS_FETCHED';
export const DECREMENT_SELECTED_MONTH = 'DECREMENT_SELECTED_MONTH';
export const DECREMENT_SELECTED_WEEK = 'DECREMENT_SELECTED_WEEK';
export const DELETE_SELECTED_DEVICE = 'DELETE_SELECTED_DEVICE';
export const DESELECT_ISSUE = 'DESELECT_ISSUE';
export const DESELECT_ALL_ISSUES = 'DESELECT_ALL_ISSUES';
export const DEVICE_BRAND_SELECTED = 'DEVICE_BRAND_SELECTED';
export const DEVICE_COLOR_SELECTED = 'DEVICE_COLOR_SELECTED';
export const DEVICE_FETCHED = 'DEVICE_FETCHED';
export const DEVICE_FETCHED_ERROR = 'DEVICE_FETCHED_ERROR';
export const DEVICE_MODEL_SELECTED = 'DEVICE_MODEL_SELECTED';
export const DEVICE_TYPE_SELECTED = 'DEVICE_TYPE_SELECTED';
export const DEVICES_FETCHED = 'DEVICES_FETCHED';
export const DEVICES_FETCHED_ERROR = 'DEVICES_FETCHED_ERROR';
export const DEVICES_FETCHING = 'DEVICES_FETCHING';
export const DEVICE_TYPES_FETCHING = 'DEVICE_TYPES_FETCHING';
export const DEVICE_TYPES_FETCHED = 'DEVICE_TYPES_FETCHED';
export const DEVICE_TYPES_FETCHED_ERROR = 'DEVICE_TYPES_FETCHED_ERROR';
export const DISABLE_ALT_TIMES = 'DISABLE_ALT_TIMES';
export const DISCLAIMER_FETCHED = 'DISCLAIMER_FETCHED';
export const DISCLAIMER_FETCHED_ERROR = 'DISCLAIMER_FETCHED_ERROR';
export const DISCLAIMER_FETCHING = 'DISCLAIMER_FETCHING';
export const DYNAMIC_CONTENT_FETCHING = 'DYNAMIC_CONTENT_FETCHING';
export const DYNAMIC_CONTENT_FETCHED = 'DYNAMIC_CONTENT_FETCHED';
export const DYNAMIC_CONTENT_FETCHED_ERROR = 'DYNAMIC_CONTENT_FETCHED_ERROR';
export const GROUP_FETCHED = 'GROUP_FETCHED';
export const GROUP_FETCHED_ERRORED = 'GROUP_FETCHED_ERRORED';
export const GROUP_FETCHED_INACTIVE = 'GROUP_FETCHED_INACTIVE';
export const GROUP_FETCHING = 'GROUP_FETCHING';
export const INCREMENT_SELECTED_MONTH = 'INCREMENT_SELECTED_MONTH';
export const INCREMENT_SELECTED_WEEK = 'INCREMENT_SELECTED_WEEK';
export const ISSUES_FETCHING = 'ISSUES_FETCHING';
export const ISSUES_FETCHED = 'ISSUES_FETCHED';
export const ISSUES_FETCHED_ERROR = 'ISSUES_FETCHED_ERROR';
export const NEARBY_STORES_FETCHING = 'NEARBY_STORES_FETCHING';
export const NEARBY_STORES_FETCHED_ERROR = 'NEARBY_STORES_FETCHED_ERROR';
export const NEARBY_STORES_FETCHED = 'NEARBY_STORES_FETCHED';
export const PAGE_TEXT_FETCHING = 'PAGE_TEXT_FETCHING';
export const PAGE_TEXT_FETCHED = 'PAGE_TEXT_FETCHED';
export const PRESSED_BACK = 'PRESSED_BACK';
export const PRICES_FETCHED = 'PRICES_FETCHED';
export const PRICES_FETCHED_ERRORED = 'PRICES_FETCHED_ERRORED';
export const PRICES_FETCHING = 'PRICES_FETCHING';
export const REPAIR_FETCHING = 'REPAIR_FETCHING';
export const REPAIR_FETCHED = 'REPAIR_FETCHED';
export const REPAIR_FETCHED_ERROR = 'REPAIR_FETCHED_ERROR';
export const REVIEW_FETCHED = 'REVIEW_FETCHED';
export const RESCHEDULING_REPAIR = 'RESCHEDULING_REPAIR';
export const RESCHEDULE_REPAIR_FAILURE = 'RESCHEDULE_REPAIR_FAILURE';
export const RESCHEDULE_REPAIR_SUCCESS = 'RESCHEDULE_REPAIR_SUCCESS';
export const RESET_DEVICE_DETAILS = 'RESET_DEVICE_DETAILS';
export const RESET_SCHEDULED_WINDOW = 'RESET_SCHEDULED_WINDOW';
export const SAVE_COMMENT = 'SAVE_COMMENT';
export const SAVE_INSTRUCTIONS = 'SAVE_INSTRUCTIONS';
export const SAVE_ISSUES_DESCRIPTION = 'SAVE_ISSUES_DESCRIPTION';
export const SCHEDULABLE_WINDOW_VALIDATING = 'SCHEDULABLE_WINDOW_VALIDATING';
export const SCHEDULABLE_WINDOW_VALIDATED = 'SCHEDULABLE_WINDOW_VALIDATED';
export const SCHEDULABLE_WINDOW_VALIDATED_ERROR =
  'SCHEDULABLE_WINDOW_VALIDATED_ERROR';
export const SCHEDULABLE_WINDOWS_FETCHING = 'SCHEDULABLE_WINDOWS_FETCHING';
export const SCHEDULABLE_WINDOWS_FETCHED = 'SCHEDULABLE_WINDOWS_FETCHED';
export const SCHEDULABLE_WINDOWS_FETCHED_ERROR =
  'SCHEDULABLE_WINDOWS_FETCHED_ERROR';
export const SELECTED_DAY_CHANGED = 'SELECTED_DAY_CHANGED';
export const SELECT_ISSUE = 'SELECT_ISSUE';
export const SELECT_LOCATION = 'SELECT_LOCATION';
export const SELECT_FIXT_RATING = 'SELECT_FIXT_RATING';
export const SELECT_PREFERRED_TIME = 'SELECT_PREFERRED_TIME';
export const SELECT_TECH_RATING = 'SELECT_TECH_RATING';
export const SELECT_SERVICE_OPTION = 'SELECT_SERVICE_OPTION';
export const SELECT_STORE = 'SELECT_STORE';
export const SET_PROTECTED_DEVICE = 'SET_PROTECTED_DEVICE';
export const SET_CONFIGURABLE_FIELDS = 'SET_CONFIGURABLE_FIELDS';
export const SET_DEVICE_FROM_CUSTOMER_DETAILS =
  'SET_DEVICE_FROM_CUSTOMER_DETAILS';
export const SETTINGS_FETCHING = 'SETTINGS_FETCHING';
export const SETTINGS_FETCHED = 'SETTINGS_FETCHED';
export const SETTINGS_FETCHED_ERROR = 'SETTINGS_FETCHED_ERROR';
export const SERVICE_OPTIONS_FETCHING = 'SERVICE_OPTIONS_FETCHING';
export const SERVICE_OPTIONS_FETCHED = 'SERVICE_OPTIONS_FETCHED';
export const SERVICE_OPTIONS_FETCHED_ERROR = 'SERVICE_OPTIONS_FETCHED_ERROR';
export const STRIPE_TOKEN_FETCHING = 'STRIPE_TOKEN_FETCHING';
export const STRIPE_TOKEN_FETCHED = 'STRIPE_TOKEN_FETCHED';
export const STRIPE_TOKEN_FETCHED_ERROR = 'STRIPE_TOKEN_FETCHED_ERROR';
export const SUBMITTING_REPAIR = 'SUBMITTING_REPAIR';
export const SUBMIT_REPAIR_FAILED = 'SUBMIT_REPAIR_FAILED';
export const STRIPE_CUSTOMER_CREATED = 'STRIPE_CUSTOMER_CREATED';
export const STRIPE_CUSTOMER_CREATE_FAILURE = 'STRIPE_CUSTOMER_CREATE_FAILURE';
export const TIME_WINDOW_SELECTED = 'TIME_WINDOW_SELECTED';
export const TIME_WINDOW_DELETED = 'TIME_WINDOW_DELETED';
export const UNSUPPORTED_PRODUCT_SELECTED = 'UNSUPPORTED_PRODUCT_SELECTED';
export const UPDATE_CONTACT = 'UPDATE_CONTACT';
export const UPDATE_CREATOR = 'UPDATE_CREATOR';
export const UPDATE_MSISDN = 'UPDATE_MSISDN';
export const UPDATE_PROGRESS_BAR = 'UPDATE_PROGRESS_BAR';
export const UPDATE_REQUEST_FIELD = 'UPDATE_REQUEST_FIELD';
export const UPDATE_SERVICE_OPTIONS = 'UPDATE_SERVICE_OPTIONS';
export const UPDATE_SELECTED_STORE = 'UPDATE_SELECTED_STORE';
export const UPDATE_SELECTED_STORE_SUCCESS = 'UPDATE_SELECTED_STORE_SUCCESS';
export const UPDATE_SELECTED_STORE_ERROR = 'UPDATE_SELECTED_STORE_ERROR';
export const USE_REPAIR_ADDRESS_FOR_BILLING = 'USE_REPAIR_ADDRESS_FOR_BILLING';
export const SELECT_LOCALE = 'SELECT_LOCALE';
export const TRANSLATED_ISSUES = 'TRANSLATED_ISSUES';

// Mixpanel Tracking Actions
export const CLICKED_BUTTON = 'CLICKED_BUTTON';
export const COMPLETED_STEP = 'COMPLETED_STEP';
export const FAILED_STEP = 'FAILED_STEP';
export const SELECTED_OPTION = 'SELECTED_OPTION';
export const TOGGLED_DROPDOWN = 'TOGGLED_DROPDOWN';
export const TYPED_IN_TEXT_FIELD = 'TYPED_IN_TEXT_FIELD';
export const VIEWED_STEP = 'VIEWED_STEP';

// hide CurrentLocation when app is viewed through iFrame in Portal
// TODO: find better name for this action
export const HIDE_CURRENT_LOCATION = 'HIDE_CURRENT_LOCATION';
